import type { ScreenSchema } from './types';

const accordionSchema: ScreenSchema = {
  template: 'accordion',
  managesOwnSectionAudio: true,
  slots: {
    intro: {
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        { field: 'instructions' }
      ]
    },
    accordion: {
      iterate: 'accordions',
      keyPrefix: 'accordion',
      // Accordion audio markers use ${item.id}-accordion-${i}, not ${screen.id}
      useItemId: true,
      parts: [
        { field: 'heading', fallback: ['subheading', 'title'] },
        { field: 'text' },
        // Fold a card's nested `templates[]` (e.g. an image-list) into its clip —
        // uc-content renders these as nested (silent) screens (see tabs schema).
        {
          iterateField: 'templates',
          parts: [
            { field: 'heading', fallback: ['subheading', 'title'] },
            { field: 'text' },
            { field: 'instructions' },
            { iterateField: 'items', parts: [{ field: 'text' }] }
          ]
        }
      ]
    }
  }
};

export default accordionSchema;
